<div class="step-card">
  <div class="step-cart__header">
    <app-icon [svgIcon]="icon" [class]="'step-card__icon'"></app-icon>
  </div>
  <div class="step-card__content">
    <div class="heading-xs step-card__title">
      {{ title }}
    </div>
    <div class="body-m step-card__description">
      {{ description }}
    </div>
  </div>
</div>
